import { Play } from "lucide-react";

export function VideoTutorials() {
  const videos = [
    {
      title: "Getting Started with Kustomer Suite",
      views: "950",
      timeAgo: "2 days ago",
      duration: "5:24",
      gradientFrom: "from-blue-400",
      gradientTo: "to-purple-500",
      playButtonColor: "text-blue-600",
    },
    {
      title: "How to Create Your First Broadcast Campaign",
      views: "1,234",
      timeAgo: "5 days ago",
      duration: "8:12",
      gradientFrom: "from-pink-400",
      gradientTo: "to-red-500",
      playButtonColor: "text-pink-600",
    },
    {
      title: "Training Your AI with Knowledge Base Documents",
      views: "782",
      timeAgo: "1 week ago",
      duration: "6:45",
      gradientFrom: "from-green-400",
      gradientTo: "to-teal-500",
      playButtonColor: "text-green-600",
    },
  ];

  return (
    <div className="flex-1 mt-12">
      {/* Section Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Video Tutorials</h2>
          <p className="text-sm text-gray-500 mt-1">Watch step-by-step guides</p>
        </div>
        <button className="text-sm text-blue-600 hover:text-blue-700 font-medium transition-colors">
          View All →
        </button>
      </div>

      {/* Video Grid (3 columns) */}
      <div className="grid grid-cols-3 gap-6">
        {videos.map((video, index) => (
          <div
            key={index}
            className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow group cursor-pointer"
          >
            {/* Thumbnail */}
            <div className={`relative aspect-video bg-gradient-to-br ${video.gradientFrom} ${video.gradientTo}`}>
              {/* Play button overlay */}
              <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/40 transition-colors">
                <div className="w-16 h-16 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <Play className={`w-8 h-8 ${video.playButtonColor} ml-1`} />
                </div>
              </div>
              {/* Duration badge */}
              <div className="absolute bottom-3 right-3 px-2 py-1 bg-black/80 text-white rounded text-xs font-medium">
                {video.duration}
              </div>
            </div>

            {/* Info */}
            <div className="p-4">
              <h3 className="text-sm font-semibold text-gray-900 mb-2 line-clamp-2">{video.title}</h3>
              <p className="text-xs text-gray-500">
                {video.views} views • {video.timeAgo}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
